import TimerTemplatePreview from '@components/templates/timerTemplatePreview';
import { getDefaultCountdownPosition } from '@lib/countdownPosition';
import { TIMER_TEMPLATES, TimerTemplateId } from '@lib/timerTemplates';
import { TimerType } from '@/types';

interface TemplateSelectionStepProps {
	timerType: TimerType;
	/** Null when nothing is chosen yet, or the timer predates templates. */
	selectedTemplateId: string | null;
	onSelect: (templateId: TimerTemplateId) => void;
}

export default function TemplateSelectionStep({ timerType, selectedTemplateId, onSelect }: TemplateSelectionStepProps) {
	const isProductContainer = timerType === TimerType.PRODUCT_CONTAINER;
	const countdownPosition = getDefaultCountdownPosition(timerType);

	return (
		<div className={`grid w-full grid-cols-1 ${isProductContainer ? 'gap-5 lg:grid-cols-2' : 'gap-3'}`}>
			{TIMER_TEMPLATES.map((template) => {
				const isSelected = selectedTemplateId === template.id;

				return (
					<button
						key={template.id}
						type='button'
						className={`group relative overflow-hidden rounded-[22px] border-2 p-0 text-left transition hover:border-[#116DFF] hover:shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#116DFF] ${
							isSelected ? 'border-[#116DFF]' : 'border-transparent'
						} ${isProductContainer ? 'min-h-[190px]' : 'min-h-[146px]'}`}
						aria-label={template.name}
						aria-pressed={isSelected}
						onClick={() => onSelect(template.id)}
					>
						<span
							className={`absolute left-4 top-4 z-10 grid h-8 w-8 place-items-center rounded-full bg-white shadow-inner ${
								isSelected ? '' : 'border-4 border-[#D0D7DF] group-hover:border-[#116DFF]'
							}`}
						>
							{isSelected && <span className='h-3 w-3 rounded-full bg-[#116DFF]' />}
						</span>
						<TimerTemplatePreview
							template={template}
							countdownPosition={countdownPosition}
							isWide={!isProductContainer}
						/>
					</button>
				);
			})}
		</div>
	);
}
